import { Box, SimpleGrid } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { RootState, ITag } from 'constants/interfaces'
import { NoResults } from 'components/CommonComponents/GroupsTree/NoResults'
import { TagsTable } from './TagsTable'
import { BoardHeader } from '../commonUI/BoardHeader'
import { TagCard } from './TagCard'
import { useTagModals } from './TagModalsManagerContext'
import React from 'react'
import useLocaleText from 'components/useLocaleText'

interface TagsBoardContentProps {
  tags: ITag[]
  viewMode: 'grid' | 'table'
  onChangeViewMode: () => void
  searchQuery: string
  onSearch: (val: string) => void
  loadingTags: Record<string, boolean>
}

export const TagsBoardContent: React.FC<TagsBoardContentProps> = ({
  tags,
  viewMode,
  onChangeViewMode,
  searchQuery,
  onSearch,
  loadingTags,
}) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  const { openTagModal, requestDeleteTag } = useTagModals()
  const create_tag = useLocaleText('create_tag')

  return (
    <Box>
      <BoardHeader
        title="tags"
        count={tags.length}
        searchPlaceholder="search"
        createButtonText={create_tag}
        onSearch={onSearch}
        onCreate={() => openTagModal()}
        viewMode={viewMode}
        onViewModeChange={onChangeViewMode}
        theme={theme}
        searchValue={searchQuery}
      />

      <Box position="relative" zIndex={1}>
        {tags.length > 0 ? (
          viewMode === 'grid' ? (
            <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 3 }} spacing={4}>
              {tags.map((tag) => (
                <TagCard
                  key={tag.sk}
                  tag={tag}
                  onEdit={(sk) => openTagModal(tags.find((t) => t.sk === sk))}
                  onDelete={(sk) => requestDeleteTag(tags.find((t) => t.sk === sk)!)}
                  isLoading={loadingTags[tag.sk] || false}
                />
              ))}
            </SimpleGrid>
          ) : (
            <TagsTable
              onEditTag={(sk) => openTagModal(tags.find((t) => t.sk === sk))}
              onDeleteTag={(sk) => requestDeleteTag(tags.find((t) => t.sk === sk)!)}
              loadingTags={loadingTags}
              searchQuery={searchQuery}
            />
          )
        ) : (
          <NoResults />
        )}
      </Box>
    </Box>
  )
}
